export class Preference {
	code: string | undefined;
	value: string | undefined;

	public static create(code: string): Preference {
		const pref = new Preference;
		pref.code = code;
		return pref;
	}
}
